import React, { Component } from 'react'

import { Field } from 'redux-form'
import { Input } from 'components/Input/Input'

import Button from 'components/Button'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import { vRequired, vStandardNumber } from 'components/Input/Input.validations'

export default class NumbersOtherSettingsStep extends Component {
  componentWillMount() {
    const { change, formData } = this.props
    change(
      'customerReference',
      `${formData.productId} - ${formData.numberWithLetters || formData.number}`
    )
  }
  render() {
    const { prev } = this.props
    return (
      <div>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Nearly there, now this is the section where we forward your calls to an answer point that
          works for you. This can be your primary office phone or even your mobile number.
        </div>
        <Field
          label="Call Forwarding Number"
          component={Input}
          name="forwardingNumber"
          type="number"
          validate={[vRequired, vStandardNumber]}
        />
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Are you going to have multiple numbers on your account? Consider adding a reference name
          below. This will help you identify this number.
        </div>
        <Field
          label="Reference name (for your use only)"
          component={Input}
          name="customerReference"
          type="text"
        />
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button color="tertiary" type="submit">
            Next
          </Button>
          <br />
          <br />
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersOtherSettingsStep/NumbersOtherSettingsStep.jsx